import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/connected/navbar";
import PersonalBgImage from "../assets/images/landing_page_personal_background.32cdaa52.svg";
// import blurPersonalBgImage from "../assets/images/landing_page_personal_corner_decoration.13b0758c.png";
const BusinessPage = () => {
  return (
    <main>
      <section
        style={{
          background: `url(${PersonalBgImage})`,
          width: "100%",
          height: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Navbar />
        <div className="container mx-auto flex items-center h-[70vh]">
          <div>
            <div className="container mx-auto flex flex-col space-y-4 md:space-y-0 md:flex-row justify-center md:text-left text-center items-center text-white md:space-x-12">
              <div className="w-full md:w-8/12">
                <div className="flex flex-col xl:space-y-8 md:space-y-4 space-y-2">
                  <p className="font-black text-xl md:text-5xl ">
                    We will help you change your life.
                  </p>
                  <h3 className="text-3xl">
                    Secure, own and manage your personal and finacial data with.
                    ease.
                  </h3>
                  <div className="flex md:justify-start justify-center ">
                    <Link
                      to=""
                      className=" w-fit bg-RubberDuckyYellow text-black font-semibold px-6 py-2 rounded-xl text-md md:text-xl"
                    >
                    Download Google store
                    </Link>
                  </div>
                  <div className="flex md:justify-start justify-center ">
                    <Link
                      to=""
                      className=" w-fit bg-RubberDuckyYellow text-black font-semibold px-6 py-2 rounded-xl text-md md:text-xl"
                    >
                    Download App store
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-4/12 text-right">
                <p className="text-2xl mb-4">Read the term and condition below.</p>
                <div className="flex flex-col space-y-3 text-left">
                  <button className="font-medium bg-blue-600  rounded-md px-6 py-2 text-lg flex justify-start">
                    Beneficiary term and condition
                  </button>
                  <button className="font-medium bg-blue-600  rounded-md px-6 py-2 text-lg flex justify-start">
                    Donor term and condition
                  </button>
                  {/* <button className="font-medium bg-blue-600  rounded-md px-6 py-2 text-lg flex justify-start">
                    I want to store all assets in one place
                  </button> */}
                  <button className="font-medium bg-blue-600  rounded-md px-6 py-2 text-lg flex justify-start">
                    Restaurant term and condition
                  </button>
                  {/* <button className="font-medium bg-blue-600  rounded-md px-6 py-2 text-lg flex justify-start">
                    I want to get paid for my data soon
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 w-full py-4 bg-blue-600 text-center">
          <p className="text-xl md:text-3xl text-white">
            {/* Be the first to use SaveHunger for free sign up now */}
          </p>
        </div>
      </section>
    </main>
  );
};

export default BusinessPage;

